import { FormGroup, FormSection, TextArea } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';
import { useFormContext } from '@frontend/utils/hooks/useFormContext';
import type { OrderSuppliesFormState } from '../../types/orderSuppliesFormState';
import { OrderSuppliesOrderAlert } from './OrderSuppliesOrderAlert';
import { OrderSuppliesOrderAmount } from './OrderSuppliesOrderAmount';
import { OrderSuppliesOrderProduct } from './OrderSuppliesOrderProduct';

export function OrderSuppliesOrder() {
    const translate = getSelectedLanguage();
    const form = useFormContext<OrderSuppliesFormState>();

    return (
        <FormSection title={translate.orderSupplies.order}>
            <OrderSuppliesOrderAlert />
            <OrderSuppliesOrderProduct />
            <OrderSuppliesOrderAmount />
            <FormGroup label={translate.orderSupplies.additionalNotes}>
                <TextArea
                    disabled={form.isSubmitting}
                    name="order.additionalNotes"
                    onBlur={form.handleBlur}
                    onChange={form.handleChange}
                    value={form.values.order.additionalNotes ?? ''}
                />
            </FormGroup>
        </FormSection>
    );
}
